<template>
  <div>
    <h1 class='display-2'>404</h1>
    <p>
      Nie znaleziono strony o podanym adresie.<br/>
      Aby przejść do strony głównej kliknij <router-link active-class="activeNav" to="/" exact>tutaj</router-link>
    </p>
  </div>
</template>

<script>
export default {
  name: 'site_404'
}
</script>



// WEBPACK FOOTER //
// src/components/404.vue